import { render, staticRenderFns } from "./channel-list-tabs.vue?vue&type=template&id=1ade4b76&"
import script from "./channel-list-tabs.vue?vue&type=script&lang=ts&"
export * from "./channel-list-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports